import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("text-video-bottom", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-video-bottom"),
    model: {
      defaults: {
        type: "video",
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        editable: true,
        stylable: ["background-color"],
      },
    },
  });

  BlockManager.add("text-video-bottom", {
    ...config,
    label: "Title, text and video below",
    content: template,
  });
}
